export interface IStatisticsStore {
  usersList: User[];
  adminsList: User[];
  usersStatistics: UserStatistics;
  preRegisteredUsers: IPreRegisteredUser[];
  loading: boolean;
  chartData: number[];
  totalPreRegisteredUsers: number;
  numberOfUsers: number;
  usersDetailedStatistics: UsersDetailedStatistcs;
  usersDetailedChartLabels: string [];

  getAllUsers(pageNumber: number, pageSize: number, adminUsers: boolean, filterValue?: string, isSuspended?:boolean, accessLevel?: AccessLevel): Promise<void>;
  getUsersStatistics(): Promise<void>;
  getPreRegisteredUsers(pageNumber: number, pageSize: number, filterValue?: string): Promise<void>;
  getUsersDetailedStatistics(from?: number | Date | string , to?: number | Date | string): Promise<void>;
  clearUsersList(): void;
}

export interface User {
  userId: number;
  firstName: string;
  firstNameAr: string;
  membershipId: string;
  phoneNumber: string;
  createdAt: string;
  title?: string;
  isSuspended?: boolean;
  isMainMember?: boolean;
  accessLevel?: AccessLevel;
  registrationSource?: RegistrationSources;
  lastActivityDate: string;
  appVersion: string;
}

export interface UserStatistics {
  registeredFromPortal: number;
  registeredFromMobile: number;
  registeredFromSportsReservation: number;
  registeredFromUnknown: number;
  totalRegisteredUsers: number;
}

export enum RegistrationSources {
  mobileApp = 'mobile',
  webPortal = 'portal',
  sportsReservation = 'sportsReservation',
  unknown = 'unknown', // users with null registration source
}
export const defaultUserStatistics = {
  registeredFromPortal: 1,
  registeredFromMobile: 1,
  registeredFromSportsReservation: 1,
  registeredFromUnknown: 1,
  totalRegisteredUsers: 0,
};
export interface UsersDetailedStatistcs {
  [RegistrationSources.mobileApp]: number [];
  [RegistrationSources.webPortal]: number [];
  [RegistrationSources.sportsReservation]: number [];
  [RegistrationSources.unknown]: number [];
}
export interface UserDetailedChartLabel {
  day: string | number;
  month: string | number;
  year: string | number;
}

export const defaultDetailedData: UsersDetailedStatistcs = {
  [RegistrationSources.mobileApp]: [],
  [RegistrationSources.webPortal]: [],
  [RegistrationSources.sportsReservation]: [],
  [RegistrationSources.unknown]: [],
};

export interface IPreRegisteredUser {
  membershipId: string;
  phoneNumber: string;
  verificationCode: string;
}

export enum AccessLevel {
  full = "full",
  limited = "limited",
}